import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
const ServicesView = () => import('@/views/ServicesView.vue')
const CertificacionesView = () => import('@/views/CertificacionesView.vue')
const ContactoView = () => import('@/views/ContactoView.vue')
const SomosView = () => import('@/views/SomosView.vue')
import seoData from '@/assets/data/seo.json'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { seoKey: 'home' }
  },
  {
    path: '/servicios',
    name: 'servicios',
    component: ServicesView,
    meta: { seoKey: 'servicios' }
  },
  {
    path: '/servicios/:serviceIndex',
    name: 'servicio-detalle',
    component: ServicesView,
    props: true,
    meta: { seoKey: 'servicios' }
  },
  {
    path: '/somos',
    name: 'somos',
    component: SomosView,
    meta: { seoKey: 'somos' }
  },
  {
    path: '/certificaciones',
    name: 'certificaciones',
    component: CertificacionesView,
    meta: { seoKey: 'certificaciones' }
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: ContactoView,
    meta: { seoKey: 'contacto' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    // Si hay un hash, va a esa sección
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    // Si no hay hash, va al principio
    return { top: 0, behavior: 'smooth' }
  }
})

// Función para actualizar los meta tags
function updateMetaTags(seo) {
  // Actualizar title
  document.title = seo.title || seoData.default.title

  // Actualizar o crear meta description
  updateMetaTag('name', 'description', seo.description || seoData.default.description)
  
  // Actualizar o crear meta keywords
  updateMetaTag('name', 'keywords', seo.keywords || seoData.default.keywords)
  
  // Open Graph tags
  updateMetaTag('property', 'og:title', seo.ogTitle || seo.title)
  updateMetaTag('property', 'og:description', seo.ogDescription || seo.description)
  updateMetaTag('property', 'og:image', window.location.origin + seo.ogImage)
  updateMetaTag('property', 'og:url', window.location.href)
  updateMetaTag('property', 'og:type', 'website')
  updateMetaTag('property', 'og:site_name', 'ESAMI')
  updateMetaTag('property', 'og:locale', 'es_CL')
  
  // Twitter Card tags
  updateMetaTag('name', 'twitter:card', 'summary_large_image')
  updateMetaTag('name', 'twitter:title', seo.ogTitle || seo.title)
  updateMetaTag('name', 'twitter:description', seo.ogDescription || seo.description)
  updateMetaTag('name', 'twitter:image', window.location.origin + seo.ogImage)
  
  // Actualizar canonical URL
  updateCanonicalURL()
}

// Función auxiliar para actualizar o crear meta tags
function updateMetaTag(attribute, key, content) {
  let element = document.querySelector(`meta[${attribute}="${key}"]`)
  
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  
  element.setAttribute('content', content)
}

// Función para actualizar la URL canónica
function updateCanonicalURL() {
  let canonical = document.querySelector('link[rel="canonical"]')
  
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  
  canonical.setAttribute('href', window.location.href)
}

// Hook antes de cada navegación
router.beforeEach((to, from, next) => {
  // Obtener la clave SEO de la ruta
  const seoKey = to.meta.seoKey || 'default'
  
  // Obtener los datos SEO correspondientes
  const seo = seoData[seoKey] || seoData.default
  
  // Actualizar los meta tags
  updateMetaTags(seo)
  
  next()
})

export default router
